"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("@emotion/react");
var makeInputStyles = function (_a) {
    var _b, _c, _d;
    var isAnswered = _a.isAnswered, isOtherOption = _a.isOtherOption, isSafari = _a.isSafari, isAutoFilledActive = _a.isAutoFilledActive, error = _a.error;
    var theme = (0, react_1.useTheme)();
    var autofillColor = isSafari ? 'rgb(250, 255, 189)' : 'rgb(232, 240, 254)';
    return {
        input: (0, react_1.css)(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({ position: 'relative', backgroundColor: theme.mvf.palette.background.answerBackgroundColor, border: 'solid', borderWidth: theme.mvf.border.width.thin, borderColor: theme.mvf.palette.component.answerUnselectedColor, boxShadow: theme.mvf.boxShadow.timid, overflow: 'hidden', borderRadius: 4, height: '60px', '@media (hover: hover)': {
                '&:hover': {
                    borderColor: theme.mvf.palette.component.answerSelectedColor,
                },
            }, '& svg.MuiSvgIcon-root': {
                transition: 'fill 200ms cubic-bezier(0, 0, 0.2, 1) 0ms',
            }, '& input, & textarea': __assign(__assign({ paddingTop: '18.5px', paddingBottom: '18.5px' }, (!isOtherOption && {
                paddingLeft: theme.mvf.spacing.medium,
                paddingRight: '55px',
            })), (_b = { fontWeight: theme.mvf.typography.weight.thick, '&::placeholder': {
                        fontWeight: theme.mvf.typography.weight.medium,
                    }, fontSize: theme.mvf.fontSize.mini }, _b[theme.breakpoints.up('mobileMedium')] = {
                fontSize: theme.mvf.fontSize.small,
            }, _b)) }, (isAnswered && {
            borderColor: theme.mvf.palette.component.answerSelectedColor,
            '& .MuiSvgIcon-root': {
                color: theme.mvf.palette.component.answerSelectedColor,
            },
        })), (!isAnswered && {
            '& .MuiSvgIcon-root': {
                color: theme.mvf.palette.text.primaryTextColor,
            },
        })), (isAutoFilledActive && {
            backgroundColor: autofillColor,
            '& input:-webkit-autofill, & textarea:-webkit-autofill': {
                backgroundColor: autofillColor,
            },
        })), { '& input:-webkit-autofill, & textarea:-webkit-autofill': {
                backgroundColor: isSafari ? 'rgb(250, 255, 189)' : 'rgb(232, 240, 254)',
            } }), (isOtherOption && {
            height: 27.2,
            border: 0,
            boxShadow: 'none',
            backgroundColor: 'transparent',
            '& input': (_c = {
                    paddingTop: 0,
                    paddingBottom: 0,
                    height: 19,
                    fontWeight: theme.mvf.typography.weight.thick,
                    textAlign: 'center',
                    '&::placeholder': {
                        fontWeight: theme.mvf.typography.weight.thick,
                        color: theme.mvf.palette.text.secondaryTextColor,
                        opacity: 1,
                    },
                    fontSize: theme.mvf.fontSize.mini
                },
                _c[theme.breakpoints.up('mobileMedium')] = {
                    fontSize: theme.mvf.fontSize.small,
                },
                _c[theme.breakpoints.up('tabletSmall')] = {
                    fontSize: theme.mvf.fontSize.compact,
                },
                _c[theme.breakpoints.up('desktopMedium')] = {
                    fontSize: theme.mvf.fontSize.medium,
                },
                _c),
        })), { '& textarea': (_d = {
                    paddingTop: '18.5px',
                    paddingBottom: '18.5px',
                    paddingLeft: theme.mvf.spacing.medium,
                    paddingRight: theme.mvf.spacing.medium,
                    height: '150px !important',
                    boxSizing: 'border-box',
                    fontSize: theme.mvf.fontSize.mini
                },
                _d[theme.breakpoints.up('mobileMedium')] = {
                    fontSize: theme.mvf.fontSize.small,
                },
                _d[theme.breakpoints.up('tabletSmall')] = {
                    fontSize: theme.mvf.fontSize.compact,
                },
                _d[theme.breakpoints.up('desktopMedium')] = {
                    fontSize: theme.mvf.fontSize.medium,
                },
                _d), '&.MuiInputBase-multiline': {
                height: 150,
                maxHeight: 150,
            } }), (error && {
            borderColor: theme.mvf.palette.status.error,
            '& .MuiSvgIcon-root': {
                color: theme.mvf.palette.status.error,
            },
            '@media (hover: hover)': {
                '&:hover': {
                    borderColor: theme.mvf.palette.status.error,
                },
            },
        })), { '&.Mui-focused:not(.Mui-error)': __assign({ boxShadow: theme.mvf.boxShadow.fierce, borderColor: theme.mvf.palette.component.answerSelectedColor, '& .MuiSvgIcon-root': {
                    color: theme.mvf.palette.component.answerSelectedColor,
                }, '@media (hover: hover)': {
                    '&:hover': {
                        borderColor: theme.mvf.palette.component.answerSelectedColor,
                    },
                } }, (isOtherOption && {
                border: 0,
                boxShadow: 'none',
                '& input::placeholder': {
                    color: '#8d8d8d',
                    fontWeight: theme.mvf.typography.weight.medium,
                },
            })) })),
        validationIcon: (0, react_1.css)({
            fontSize: theme.mvf.fontSize.big,
        }),
        adornmentEnd: (0, react_1.css)({
            position: 'absolute',
            right: theme.mvf.spacing.medium,
        }),
        adornmentStart: (0, react_1.css)({
            marginRight: theme.mvf.spacing.small,
            marginLeft: theme.mvf.spacing.medium,
        }),
    };
};
exports.default = makeInputStyles;
//# sourceMappingURL=makeInputStyles.js.map